module.exports = __webpack_public_path__ + "static/img/barrie2.4e3b1ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/barrie2.jpg
// module id = 70
// module chunks = 9